module.exports = __webpack_public_path__ + "img/advertise001.3141b1b0.png";